import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
function ClusterToSheet() {
    var _a = useParams(), clusterPath = _a.clusterPath, clusterSelected = _a.clusterSelected;
    if (!clusterPath && !clusterSelected) {
        return React.createElement(Navigate, { to: "/sheet", replace: true });
    }
    if (!clusterSelected) {
        return React.createElement(Navigate, { to: "/sheet/".concat(clusterPath), replace: true });
    }
    return React.createElement(Navigate, { to: "/sheet/".concat(clusterPath, "/").concat(clusterSelected), replace: true });
}
export default ClusterToSheet;
